<template>
    <component
        v-if="showWelcome || userIsEmpty('user') && anonAllowedRoutes.indexOf(pathname) < 0"
        @click="$modal.show('welcome')"
        :is="tag || 'span'"
        v-html="html"
    ></component >
    <router-link
        v-else
        :tag="tag"
        :to="{ name: pathname, params: params}"
        v-html="html"
        :target="target"
    ></router-link>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    props:{
        pathname: {
            type: String,
            required: true
        },
        params: {
            type: Object,
            required: false
        },
        tag: {
            type: String,
            required: false
        },
        html: {
            type: String,
            required: true
        },
        target: {
            type: String,
            required: false,
            default: '_self'
        },
        showWelcome: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            anonAllowedRoutes: [
                'profile',
                'albums',
                'search',
                'horoscope',
                'home',
                'photos',
                'about',
                'rules',
                'help',
                'legal',
                'feedback',
                'advertising',
                'developers'
            ]
        }
    },
    computed: {
        ...mapGetters({
            userIsEmpty: 'user/isEmpty'
        })
    }
}
</script>
